import SelfInviteConfirmModal from './SelfInviteConfirmModal.vue';
export default SelfInviteConfirmModal;
